import { render, staticRenderFns } from "./ColumnExtraExpand.vue?vue&type=template&id=3d3ec560"
import script from "./ColumnExtraExpand.vue?vue&type=script&lang=js"
export * from "./ColumnExtraExpand.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports